/** Seed Status Updation — the desk's list of lots by status. */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { PlantRequired } from "@/components/app/plant-required";
import { SeedStatusPage } from "@/features/warehouse/components/seed-status-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

const search = z.object({
  tab: z
    .enum(["all", "drying", "fumigation", "quarantine", "none"])
    .default("all"),
  q: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/warehouse/$stage/seed-status/")({
  validateSearch: search,
  beforeLoad: ({ params }) => guardDesk(params.stage, "warehouse.seed_status"),
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const facilityId = useDeskFacility();
  if (facilityId === undefined)
    return <PlantRequired title="Seed Status Updation" what="Seed status" />;
  return (
    <SeedStatusPage
      stage={asStage(stage)}
      facilityId={facilityId}
      search={s}
      onSearch={(next) =>
        // Any change but the page's own starts again at page 1.
        void navigate({ search: (prev) => ({ ...prev, page: 1, ...next }) })
      }
    />
  );
}
